/**
 * PageHeader Component
 * Reusable header for all pages with back-to-home button and page title
 */

import Link from "next/link";
import { Home } from "lucide-react";
import { Button } from "@/components/ui/button";

interface PageHeaderProps {
  title: string;
}

export function PageHeader({ title }: PageHeaderProps) {
  return (
    <div className="py-4">
      <div className="container mx-auto flex items-center justify-between">
         {/* Page Title */}
         <h2 className="text-xl font-bold text-gray-900 dark:text-white sm:text-2xl">
          {title}
        </h2>
        {/* Back to Home Button */}
        <Link href="/">
          <Button
            variant="secondary"
            size="lg"
            className="gap-2 text-white bg-brand-600 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100"
          >
            <Home className="h-4 w-4" />
            <span>Home</span>
          </Button>
        </Link>
      </div>
    </div>
  );
}
